// Una guía por cada apertura con nombre del libro (2026-10-21). Datos de uso: partidas entre personas
// en juegoxima.com hasta el 21-10-2026 (454 partidas en las que el primero entra en la primera jugada).

export const APERTURAS_GUIDES = [
  {
    "slug": "estrategia/apertura-capablanca",
    "theme": "estrategia",
    "nav": "Apertura Capablanca",
    "title": "Apertura Capablanca en XIMA: casillas, idea y partidas",
    "description": "La Apertura Capablanca de XIMA: en qué casillas se juega (A2, B1, L1, M2, M12, L13, B13 y A12), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Capablanca",
    "intro": "La Apertura Capablanca es la apertura más jugada de juegoxima.com. Se juega entrando en la primera jugada en una de sus 8 casillas: A2, B1, L1, M2, M12, L13, B13 y A12. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 8 casillas de la Apertura Capablanca son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A2» es la Apertura Especial Capablanca. Se llama así por José Raúl Capablanca, el gran campeón cubano de ajedrez."
        ],
        "figure": "apertura-capablanca"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Deja una escalera natural en C3 con dos vías de subida. No es tan rápida como para que el rival la bloquee fácilmente ni tan lenta como para quedarse atrás en la subida al segundo piso. Es, quizá, la más equilibrada de todas.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 105 empiezan con la Apertura Capablanca (23 %). Entre personas, el que sale con Capablanca gana el 49 % de las partidas: es tan equilibrada como dice el libro.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "AdrianWRJ (sale primero) contra yosdel, Modo Ciencia, 25 de agosto de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "AdrianWRJ",
            "yosdel"
          ],
          "rows": [
            [
              "1.",
              "-B1",
              "-M2"
            ],
            [
              "2.",
              "-C1",
              "-M3"
            ],
            [
              "3.",
              "-J1",
              "-M1"
            ]
          ]
        },
        "after": [
          "AdrianWRJ empieza en B1 y sigue por la misma cara con C1 y J1. yosdel contesta con M2, que también es una casilla de la Capablanca, en la cara de la derecha.",
          "La partida duró 99 movimientos y la ganó AdrianWRJ llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Entra en la casilla vecina a la esquina (por ejemplo A2 o B1) y apoya enseguida con un segundo bloque cerca, para tener listo el escalón hacia C3.",
          "Como tiene dos vías de subida, si el rival te tapa una todavía te queda la otra: no hace falta precipitarse.",
          "Es una buena apertura para aprender, porque obliga a pensar en escalones desde la primera jugada sin arriesgar demasiado."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-yosdel",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-tanu",
          "estrategia/apertura-muino",
          "estrategia/apertura-susy",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Capablanca?",
        "En A2, B1, L1, M2, M12, L13, B13 y A12. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Capablanca es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-yosdel",
    "theme": "estrategia",
    "nav": "Apertura Yosdel",
    "title": "Apertura Yosdel en XIMA: casillas, idea y partidas",
    "description": "La Apertura Yosdel de XIMA: en qué casillas se juega (A1, M1, M13 y A13), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Yosdel",
    "intro": "La Apertura Yosdel es la segunda apertura más jugada de juegoxima.com. Se juega entrando en la primera jugada en una de sus 4 casillas: A1, M1, M13 y A13. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 4 casillas de la Apertura Yosdel son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A1» es la Apertura Especial Yosdel. Lleva el nombre de Yosdel Vicente Muiño Acevedo, uno de los creadores de XIMA."
        ],
        "figure": "apertura-yosdel"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Sale desde una esquina y deja una escalera natural en B2 con una sola vía de subida. Es muy rápida, pero también fácil de bloquear. Busca controlar las esquinas y atacar pronto por la diagonal.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 66 empiezan con la Apertura Yosdel (14 %). Entre personas, el que sale con la Yosdel gana el 59 % de las partidas, el mejor resultado de las aperturas con más de 50 partidas jugadas.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "yosdel (sale primero) contra AdrianWRJ, Modo Ciencia, 26 de septiembre de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "yosdel",
            "AdrianWRJ"
          ],
          "rows": [
            [
              "1.",
              "-A1",
              "-M2"
            ],
            [
              "2.",
              "-A13",
              "-M12"
            ],
            [
              "3.",
              "-M7",
              "M12M2"
            ]
          ]
        },
        "after": [
          "yosdel ocupa dos esquinas, A1 y A13, en la misma cara. AdrianWRJ contesta con dos casillas de la Capablanca en la cara de enfrente (M2 y M12) y en la jugada 3 ya apila un bloque sobre otro en M2.",
          "La partida duró 58 movimientos y la ganó AdrianWRJ llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "La esquina es la casilla más alejada de la cima, pero la diagonal (A1, B2, C3…) es el camino más corto hacia el centro.",
          "Como solo tiene una vía de subida, el rival sabe por dónde vas a ir. Vigila que no te ocupe o domine la casilla del escalón.",
          "Ocupar una esquina también sirve para controlarla: el libro recomienda controlar las esquinas, ocupándolas o amenazándolas."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-tanu",
          "estrategia/apertura-muino",
          "estrategia/apertura-susy",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Yosdel?",
        "En A1, M1, M13 y A13. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Yosdel es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-parraguena",
    "theme": "estrategia",
    "nav": "Apertura Párragueña",
    "title": "Apertura Párragueña en XIMA: casillas, idea y partidas",
    "description": "La Apertura Párragueña de XIMA: en qué casillas se juega (A3, C1, K1, M3, M11, K13, C13 y A11), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Párragueña",
    "intro": "La Apertura Párragueña es una apertura poco jugada todavía. Se juega entrando en la primera jugada en una de sus 8 casillas: A3, C1, K1, M3, M11, K13, C13 y A11. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 8 casillas de la Apertura Párragueña son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A3» es la Apertura Especial Párragueña. Su nombre viene del pueblo natal de Yosdel, uno de los creadores del juego."
        ],
        "figure": "apertura-parraguena"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Deja dos escaleras naturales juntas, en C3 y D3, con cinco vías de subida. Es a la vez ofensiva y defensiva: controla el anillo interior por una banda y la esquina por la otra.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 14 empiezan con la Apertura Párragueña (3 %). Todavía hay pocas partidas con esta apertura para sacar conclusiones sobre su resultado.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "Power (sale primero) contra yosdel, Modo Ciencia, 15 de septiembre de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "Power",
            "yosdel"
          ],
          "rows": [
            [
              "1.",
              "-K1",
              "-B7"
            ],
            [
              "2.",
              "-E4",
              "-C6"
            ],
            [
              "3.",
              "-D9",
              "-C8"
            ]
          ]
        },
        "after": [
          "Power abre en K1 y, ya en la segunda jugada, mete un bloque que entra hasta E4, en el segundo piso. yosdel prefiere ocupar la cara izquierda con B7, C6 y C8.",
          "La partida duró 48 movimientos y la ganó yosdel llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Con cinco vías de subida es difícil que el rival te las tape todas: es una apertura flexible.",
          "Aprovecha que controla la esquina cercana: el libro aconseja controlar las esquinas, ocupándolas o amenazándolas.",
          "Desde aquí es natural doblar columna pronto, otro de los principios de apertura del libro."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-yosdel",
          "estrategia/apertura-tanu",
          "estrategia/apertura-muino",
          "estrategia/apertura-susy",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Párragueña?",
        "En A3, C1, K1, M3, M11, K13, C13 y A11. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Párragueña es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-tanu",
    "theme": "estrategia",
    "nav": "Apertura Tanu",
    "title": "Apertura Tanu en XIMA: casillas, idea y partidas",
    "description": "La Apertura Tanu o ucraniana de XIMA: en qué casillas se juega (A4, D1, J1, M4, M10, J13, D13 y A10), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Tanu o ucraniana",
    "intro": "La Apertura Tanu o ucraniana es una apertura poco jugada todavía. Se juega entrando en la primera jugada en una de sus 8 casillas: A4, D1, J1, M4, M10, J13, D13 y A10. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 8 casillas de la Apertura Tanu son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A4» es la Apertura Especial Tanu. También se la conoce como apertura ucraniana."
        ],
        "figure": "apertura-tanu"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Deja dos escaleras naturales y una artificial, con ocho vías de subida. Es muy útil pensando en el final, porque defiende la fila interior del segundo piso.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 12 empiezan con la Apertura Tanu (2,6 %). Todavía hay pocas partidas con esta apertura para sacar conclusiones sobre su resultado.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "CHELOPLAY (sale primero) contra Power, Modo Ciencia, 14 de agosto de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "CHELOPLAY",
            "Power"
          ],
          "rows": [
            [
              "1.",
              "-D1",
              "-A2"
            ],
            [
              "2.",
              "-E1",
              "-A3"
            ],
            [
              "3.",
              "-C1",
              "-M2"
            ]
          ]
        },
        "after": [
          "CHELOPLAY abre en D1 y rellena la misma cara con E1 y C1. Power contesta con A2 (Capablanca) y A3 (Párragueña) en la cara izquierda.",
          "La partida duró 36 movimientos y la ganó Power llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Es una apertura de largo plazo: no busca subir en dos jugadas, sino tener caminos preparados para cuando llegue el final.",
          "Con ocho vías de subida, cuesta mucho que el rival te bloquee del todo.",
          "Vigila las vías de subida del rival mientras preparas las tuyas: defender el anillo interior es uno de los principios del libro."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-yosdel",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-muino",
          "estrategia/apertura-susy",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Tanu?",
        "En A4, D1, J1, M4, M10, J13, D13 y A10. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Tanu es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-muino",
    "theme": "estrategia",
    "nav": "Apertura Muiño",
    "title": "Apertura Muiño en XIMA: casillas, idea y partidas",
    "description": "La Apertura Muiño de XIMA: en qué casillas se juega (A5, E1, I1, M5, M9, I13, E13 y A9), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Muiño",
    "intro": "La Apertura Muiño es una de las aperturas menos jugadas. Se juega entrando en la primera jugada en una de sus 8 casillas: A5, E1, I1, M5, M9, I13, E13 y A9. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 8 casillas de la Apertura Muiño son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A5» es la Apertura Especial Muiño. Lleva el apellido de Yosdel Vicente Muiño Acevedo, uno de los creadores de XIMA."
        ],
        "figure": "apertura-muino"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Deja tres escaleras naturales con nueve vías de subida. Da un gran control del segundo piso y es típica de jugadores agresivos que quieren subir el especial cuanto antes.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 4 empiezan con la Apertura Muiño (menos del 1 %). Todavía hay muy pocas partidas con esta apertura: si te gusta atacar, es terreno por explorar.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "CHELOPLAY (sale primero) contra Power, Modo Ciencia, 14 de agosto de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "CHELOPLAY",
            "Power"
          ],
          "rows": [
            [
              "1.",
              "-E1",
              "-M2"
            ],
            [
              "2.",
              "-A4",
              "-B13"
            ],
            [
              "3.",
              "-A5",
              "-M3"
            ]
          ]
        },
        "after": [
          "CHELOPLAY abre en E1 y después juega por la cara izquierda (A4 y A5). Power contesta repartiendo bloques entre la cara derecha (M2 y M3) y la de arriba (B13).",
          "La partida duró 34 movimientos y la ganó Power llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Es la apertura con más vías de subida de todas: nueve.",
          "Si tu idea es subir el especial pronto, recuerda el consejo del libro: mételo en el segundo o el tercer piso, no en el primero.",
          "Agresiva no quiere decir precipitada: el libro advierte contra salir a cazar bloques en las primeras jugadas."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-yosdel",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-tanu",
          "estrategia/apertura-susy",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Muiño?",
        "En A5, E1, I1, M5, M9, I13, E13 y A9. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Muiño es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-susy",
    "theme": "estrategia",
    "nav": "Apertura Susy",
    "title": "Apertura Susy en XIMA: casillas, idea y partidas",
    "description": "La Apertura Susy de XIMA: en qué casillas se juega (A6, F1, H1, M6, M8, H13, F13 y A8), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Susy",
    "intro": "La Apertura Susy es una de las aperturas menos jugadas. Se juega entrando en la primera jugada en una de sus 8 casillas: A6, F1, H1, M6, M8, H13, F13 y A8. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 8 casillas de la Apertura Susy son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A6» es la Apertura Especial Susy."
        ],
        "figure": "apertura-susy"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Es una de las más dinámicas: permite coordinar bloques por columnas y filas vecinas y dominar la cara de la pirámide en la que se juega.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 7 empiezan con la Apertura Susy (1,5 %). Todavía hay pocas partidas con esta apertura para sacar conclusiones sobre su resultado.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "CHELOPLAY (sale primero) contra Power, Modo Ciencia, 14 de agosto de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "CHELOPLAY",
            "Power"
          ],
          "rows": [
            [
              "1.",
              "-F1",
              "-M2"
            ],
            [
              "2.",
              "-G1",
              "-M3"
            ],
            [
              "3.",
              "-H1",
              "-L3"
            ]
          ]
        },
        "after": [
          "CHELOPLAY abre en F1 y llena el centro de la cara de abajo con G1 y H1. Power vuelve a elegir la cara derecha con M2, M3 y L3.",
          "La partida duró 28 movimientos y la ganó Power llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Sus casillas están al lado del centro de cada cara, así que es fácil apoyarlas con bloques en las casillas vecinas.",
          "Su fuerza está en coordinar: alinea y coordina tus bloques, como pide el libro.",
          "Si dominas una cara, el rival tendrá que subir por otra."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-yosdel",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-tanu",
          "estrategia/apertura-muino",
          "estrategia/apertura-liz"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Susy?",
        "En A6, F1, H1, M6, M8, H13, F13 y A8. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Susy es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
  {
    "slug": "estrategia/apertura-liz",
    "theme": "estrategia",
    "nav": "Apertura Liz",
    "title": "Apertura Liz en XIMA: casillas, idea y partidas",
    "description": "La Apertura Liz de XIMA: en qué casillas se juega (A7, G1, M7 y G13), qué busca según el libro y cómo se juega en juegoxima.com.",
    "h1": "Apertura Liz",
    "intro": "La Apertura Liz es la apertura central. Se juega entrando en la primera jugada en una de sus 4 casillas: A7, G1, M7 y G13. Aquí tienes qué busca, cuánto se juega y una partida real que empieza así.",
    "sections": [
      {
        "h": "Las casillas",
        "p": [
          "Las 4 casillas de la Apertura Liz son en realidad la misma jugada vista desde otro lado. La pirámide tiene cuatro caras iguales y cada cara es simétrica, así que entrar en cualquiera de ellas lleva a la misma idea.",
          "Si la primera jugada es con el bloque especial, se le añade la palabra «Especial»: por ejemplo, «1. =A7» es la Apertura Especial Liz. Lleva el nombre de Liz Power Suárez, la otra creadora de XIMA."
        ],
        "figure": "apertura-liz"
      },
      {
        "h": "La idea según el libro",
        "p": [
          "Sale desde el centro de una cara, en línea recta con la cima. Da mucho control desde el principio y es típica de jugadores técnicos y precisos.",
          "El libro llama escalera natural a la que permite pasar por encima del escalón y subir en un solo movimiento; en la artificial, primero hay que subirse al escalón y, en el turno siguiente, seguir subiendo. Recuerda que cada piso está dos alturas por encima del anterior y que un bloque solo sube una altura por paso: sin escalón no se sube."
        ]
      },
      {
        "h": "Cómo se juega en juegoxima.com",
        "p": [
          "De las 454 partidas entre personas de juegoxima.com que hemos revisado, 15 empiezan con la Apertura Liz (3 %). Todavía hay pocas partidas con esta apertura para sacar conclusiones sobre su resultado.",
          "La más jugada es la Capablanca (23 %), seguida de la Yosdel (14 %). Curiosamente, la mitad de los jugadores no abre en el borde sino en el segundo anillo del primer piso, en casillas como B3 o B7, que no tienen nombre en el libro."
        ]
      },
      {
        "h": "Una partida real",
        "p": [
          "yosdel (sale primero) contra Power, Modo Ciencia, 4 de septiembre de 2026. Estas fueron las tres primeras jugadas:"
        ],
        "table": {
          "head": [
            "N.º",
            "yosdel",
            "Power"
          ],
          "rows": [
            [
              "1.",
              "-G1",
              "-M2"
            ],
            [
              "2.",
              "-H1",
              "-M3"
            ],
            [
              "3.",
              "-F1",
              "-M1"
            ]
          ]
        },
        "after": [
          "yosdel abre en G1 y apoya enseguida por los dos lados, con H1 y F1. Power juega por la cara derecha: M2, M3 y la esquina M1.",
          "La partida duró 79 movimientos y la ganó yosdel llevando su especial a la cima."
        ]
      },
      {
        "h": "Consejos para jugarla",
        "list": [
          "Desde el centro de una cara, la cima está en línea recta: la columna G (o la fila 7) es el camino directo.",
          "Al estar en el medio de la cara, puede recibir apoyo por los dos lados.",
          "Precisamente porque el camino es tan directo, el rival lo ve venir: prepara bien los escalones antes de lanzarte."
        ]
      },
      {
        "h": "Las otras aperturas",
        "links": [
          "estrategia/apertura-capablanca",
          "estrategia/apertura-yosdel",
          "estrategia/apertura-parraguena",
          "estrategia/apertura-tanu",
          "estrategia/apertura-muino",
          "estrategia/apertura-susy"
        ]
      }
    ],
    "faqs": [
      [
        "¿En qué casillas se juega la Apertura Liz?",
        "En A7, G1, M7 y G13. Son la misma apertura vista desde cada lado de la pirámide."
      ],
      [
        "¿La Apertura Liz es buena?",
        "El libro aclara que no se puede decir a ciencia cierta que una apertura sea buena o mala, porque los planes posibles son infinitos. Lo importante es que tu plan encaje con ella."
      ]
    ],
    "related": [
      "estrategia/aperturas-xima",
      "estrategia/defensas-xima",
      "reglas/subir-bloques",
      "reglas/incorporar-bloque"
    ],
    "cta": {
      "label": "Todas las aperturas",
      "slug": "estrategia/aperturas-xima"
    }
  },
];
